import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { extractStringNodes } from '@costar-ui/utils';
import React, { useMemo } from 'react';
import { dividerStyles } from './divider.styles.esm.js';
import TextDivider from './text-divider/text-divider.esm.js';

var _excluded = ["className", "orientation", "light", "fullHeight", "absolute"],
  _excluded2 = ["children", "orientation"];
function PrivateDivider(props) {
  var className = props.className,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    light = props.light,
    fullHeight = props.fullHeight,
    absolute = props.absolute,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = useMemo(function () {
    return dividerStyles({
      className: className,
      orientation: orientation,
      light: light,
      absolute: absolute,
      fullHeight: fullHeight
    });
  }, [absolute, className, light, orientation, fullHeight]);
  return /*#__PURE__*/React.createElement("hr", _extends({
    role: "separator",
    className: "csg-tw-divider ".concat(classes)
  }, rest));
}
function Divider(props) {
  var children = props.children,
    _props$orientation2 = props.orientation,
    orientation = _props$orientation2 === void 0 ? 'horizontal' : _props$orientation2,
    rest = _objectWithoutProperties(props, _excluded2);
  var stringNodes = extractStringNodes(React.Children.toArray(children).filter(function (i) {
    return typeof i === 'string';
  }));
  return stringNodes.length > 0 && orientation === 'horizontal' ? /*#__PURE__*/React.createElement(TextDivider, props) : /*#__PURE__*/React.createElement(PrivateDivider, _extends({
    orientation: orientation
  }, rest));
}
Divider.displayName = 'Divider';

export { Divider as default };
//# sourceMappingURL=divider.esm.js.map
